import PermissionAccess from "./PermissionAccess";
export { PermissionAccess };
export default PermissionAccess;
